import React from "react";
import Panel from "../../ui/Panel/Panel.jsx";
import Button from "../../ui/Button/Button.jsx";

const BusinessCard = ({ business, businessTypeLabel, onContinue, onEdit, onDelete }) => (
  <Panel className="flex flex-col gap-3.5 p-[18px]">
    <div>
      <div className="font-disp text-[13px] text-[var(--muted)] tracking-[.06em]">
        {businessTypeLabel || "Business"}
      </div>
      <div className="font-disp text-xl mt-0.5 break-words">{business.name || "Unnamed business"}</div>
    </div>
    <div className="flex justify-between items-baseline border-t border-dashed border-[var(--line-2)] pt-3 text-[13px]">
      <span className="text-[var(--muted)]">EIN</span>
      <span className="font-mono">{business.ein || "—"}</span>
    </div>
    <div className="flex gap-2">
      <Button className="flex-1" onClick={onContinue}>
        Continue filing →
      </Button>
      {onEdit && (
        <Button variant="ghost" onClick={onEdit} title="Edit business details">
          Edit
        </Button>
      )}
      {onDelete && (
        <Button variant="ghost" onClick={onDelete} title="Delete business">
          Delete
        </Button>
      )}
    </div>
  </Panel>
);

export default BusinessCard;
